import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Ng2StateDeclaration, UIRouterModule } from '@uirouter/angular';
import { ForgotPasswordPageComponent } from './forgot-password-page.component';
import { FormsModule } from '@angular/forms';

const states: Ng2StateDeclaration[] = [
  {
    name: 'forgotPassword',
    url: '/forgotPassword',
    component: ForgotPasswordPageComponent,
    data: {
      requireLogin: false
    },
    params: {
      message: null
    }
  }
];

@NgModule({
  declarations: [ForgotPasswordPageComponent],
  imports: [
    CommonModule,
    FormsModule,
    UIRouterModule.forChild({ states })
  ],
  entryComponents: [ForgotPasswordPageComponent],
})
export class ForgotPasswordPageModule { }
